<template>
    <div class="home">
        <div v-if="esMovil">
            <v-img src="./Logo.png"> </v-img>
            <div class="texto mx-10" v-html="descripcionInicio"></div>
            <v-list flat class="fondo-trasparente">
                <v-list-item
                    v-for="enlace in enlacesObjetivos"
                    :key="enlace.texto"
                    :to="enlace.link"
                >
                    <v-list-item-icon>
                        <v-img :src="enlace.icono" max-width="70"></v-img>
                    </v-list-item-icon>

                    <v-list-item-content class="lista-objetivo-inicio">
                        {{ enlace.texto }}
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </div>
        <div v-else>
            <v-parallax height="500" src="/images/imagen_vinaroz.png">
                <v-row align="center" justify="center" class="align-content-center">
                    <v-col class="text-center" cols="8">
                        <h1 class="text-h3 font-weight-bold">
                            {{ $t("inicio.texto.titulo") }}
                        </h1>
                        <h4 class="mt-2 body-2" v-html="descripcionInicio"></h4>
                    </v-col>
                    <v-col class="text-center" cols="5">
                        <BuscadorIndicadores></BuscadorIndicadores>
                    </v-col>
                </v-row>
            </v-parallax>

            <v-container fluid>
                <v-row
                    dense
                    justify="space-around"
                    v-for="(listaEnlacesObjetivos, index) in listaObjetivosDividida"
                    :key="index"
                >
                    <v-col
                        v-for="enlace in listaEnlacesObjetivos"
                        :key="enlace.texto"
                        cols="2"
                    >
                        <v-card
                            :to="enlace.link"
                            class="mt-8"
                            min-width="100"
                            max-width="200"
                            min-height="200"
                            rounded="xl"
                            hover
                        >
                            <div class="pt-2">
                                <v-img :src="enlace.icono" max-width="80" class="mx-auto">
                                </v-img>
                            </div>
                            <v-card-text
                                class="text-center text-align-center lista-objetivo-inicio"
                            >
                                {{ enlace.texto }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>
<script>
import MasterdataService from "@services/MasterdataService";
import BuscadorIndicadores from "../components/BuscadorIndicadores.vue";

export default {
    name: "Inicio",
    props: [],
    components: { BuscadorIndicadores },
    data: function () {
        return {
            enlacesObjetivos: [],
            listaIndicadores: [],
            tituloInicio: this.$t("inicio.texto.descripcion"),
            descripcionInicio: this.$t("inicio.texto.descripcion"),
        };
    },
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        listaObjetivosDividida() {
            return [this.enlacesObjetivos.slice(0, 5), this.enlacesObjetivos.slice(5)];
        },
    },
    mounted() {
        MasterdataService.getEnlacesObjetivos().then((response) => {
            this.enlacesObjetivos = response.data.objetivos.map((objetivo) => ({
                ...objetivo,
                texto: this.$t(objetivo.texto),
            }));
        });
    },
};
</script>

<style scoped></style>
